import i18n from '../i18n';

export const required = (value) => (!value ? i18n.t('error.field.required') : null);
export const emailFormat = (value) => (
    value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? i18n.t('error.email.invalid') : null
);
